<template>
  <slot />
</template>

<script lang="ts">
  import { useCompanyStore } from '@/store/company';
  import { useThemeStore } from '@/store/theme';
  import { mapStores } from 'pinia';

  export default {
    name: 'WThemeProvider',

    computed: {
      ...mapStores(useCompanyStore, useThemeStore),
    },

    watch: {
      $route: async function (newRoute, oldRoute) {
        // only update themes for urls with company_id
        // everything else inherits from the default theme

        const company_id = (newRoute.params?.company_id as string) ?? null;
        const old_company_id = (oldRoute.params?.company_id as string) ?? null;

        // if this value does not change, we don't need to update the theme
        if (company_id === old_company_id) {
          return;
        }

        if (!company_id) {
          this.themeStore.resetTheme();
          this.themeStore.applyTheme();
        } else {
          try {
            const {
              properties: {
                value: { colorscheme, logo },
              },
            } = await this.companyStore.doGetCompanyConfigs(company_id);

            this.themeStore.setTheme({
              ...this.themeStore.theme,
              colorscheme,
              logo,
            });

            this.themeStore.applyTheme();
          } catch (e) {
            console.error(e);
          }
        }
      },
    },
  };
</script>
